// Central export for test IDs used by the frontend.
export const LOGIN = {
    usernameInput: 'login-username-input',
    passwordInput: 'login-password-input',
    submitButton: 'login-submit-button',
    errorText: 'login-error-text',
};

export const HEADER = {
    userMenuTrigger: 'header-user-menu-trigger',
    logoutButton: 'header-logout-button',
    profileLink: 'header-profile-link',
    adminLink: 'header-admin-link',
    dashboardLink: 'header-dashboard-link',
};

export const DASHBOARD = {
    welcomeBanner: 'dashboard-welcome-banner',
    scrollAnnouncementsButton: 'dashboard-scroll-announcements-button',
    kpiSuratMasuk: 'kpi-total-surat-masuk',
    kpiSuratKeluar: 'kpi-total-surat-keluar',
    kpiArsip: 'kpi-total-arsip',
    kpiAuditor: 'kpi-total-auditor-aktif',
    appCardIrban1: 'app-card-irban-1',
    appCardIrban2: 'app-card-irban-2',
    appCardIrban3: 'app-card-irban-3',
    appCardIrban4: 'app-card-irban-4',
    appCardIrban5: 'app-card-irban-5',
    appCardKka: 'app-card-kka',
    newsFeed: 'news-feed',
    newsItem: 'news-item-card',
    newsOpenDetail: 'news-open-detail-button',
    newsDetailDialog: 'news-detail-dialog',
    newsDetailTitle: 'news-detail-title',
    newsDetailContent: 'news-detail-content',
};

export const ADMIN = {
    usersTable: 'admin-users-table',
    usersCreateButton: 'admin-users-create-button',
    usersEditButton: 'admin-users-edit-button',
    usersDeleteButton: 'admin-users-delete-button',
    usersResetPasswordButton: 'admin-users-reset-password-button',
    userFormUsername: 'admin-user-form-username',
    userFormFullName: 'admin-user-form-full-name',
    userFormPassword: 'admin-user-form-password',
    userFormRole: 'admin-user-form-role',
    userFormSubmit: 'admin-user-form-submit',
    newsTable: 'admin-news-table',
    newsCreateButton: 'admin-news-create-button',
    newsFormTitle: 'admin-news-form-title',
    newsFormContent: 'admin-news-form-content',
    newsFormCategory: 'admin-news-form-category',
    newsFormSubmit: 'admin-news-form-submit',
    newsEditButton: 'admin-news-edit-button',
    newsDeleteButton: 'admin-news-delete-button',
    newsPublishToggle: 'admin-news-publish-toggle',
    statsForm: 'admin-stats-form',
    statsSaveButton: 'admin-stats-save-button',
    statsSuratMasuk: 'admin-stats-input-surat-masuk',
    statsSuratKeluar: 'admin-stats-input-surat-keluar',
    statsArsip: 'admin-stats-input-arsip',
    statsAuditor: 'admin-stats-input-auditor',
    linksForm: 'admin-links-form',
    linksSaveButton: 'admin-links-save-button',
};

export const PROFILE = {
    oldPassword: 'profile-old-password-input',
    newPassword: 'profile-new-password-input',
    confirmPassword: 'profile-confirm-password-input',
    saveButton: 'profile-save-password-button',
};

export const PUBLIC = {
    heroSection: 'public-hero-section',
    loginCta: 'public-login-cta',
    portalCta: 'public-portal-cta',
    newsSection: 'public-news-section',
    newsCard: 'public-news-card',
    newsListItem: 'public-news-list-item',
    newsReadMoreLink: 'public-news-read-more',
    newsDetailTitle: 'public-news-detail-title',
    newsDetailContent: 'public-news-detail-content',
    newsDetailBack: 'public-news-detail-back',
};
